import React from "react"
import { navigationItemArrow } from "../../../../../../../../../static/svgs/navigation"
import Texts, { TextColor, TextWeight } from "../../../../../../../../Texts"

type Props = {
  children: React.ReactNode
  isOpen: boolean
}

const ListItemContent = ({ children, isOpen }: Props) => (
  <div className="flex items-center justify-between sm:p-1 md:p-0">
    <div className="sm:pr-2 md:pr-8">
      <Texts.Button1 color={TextColor.White} weight={TextWeight.Regular}>
        {children}
      </Texts.Button1>
      <div>
        <div
          className={`border-t-2 transition-all border-igem-dark-blue border-opacity-0 group-hover:border-igem-blue`}
        ></div>
      </div>
    </div>
    <div>
      <img
        alt="arrow"
        className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        src={navigationItemArrow}
      />
    </div>
  </div>
)

export default ListItemContent
